import {postRequest, putRequest} from "../../src/api/index.js";
import {PAGE_ACCESS, PAGE_ACCESS_ERROR} from "../../src/actions/types.js";

export const markUserAsRegisteredToANewOrbit = async (data, cb) => async (
    dispatch
) => {
    try {
        // Every status but 401 comes back here, as before TO-1872: the checks below read the error answers
        // (otp_expiration, errors[]). A 401 still goes to the sign-out interceptor.
        const res = await postRequest(`/user/markuserasregisteredtoaneworbit`, "user", data, (status) => status !== 401);

        if (res.status === 200) {
            cb({
                success: true
            });
        } else {
            cb({
                success: false
            });
        }
    } catch (err) {
        if (err.response) {
            // There is an error response from the server
            // You can anticipate error.response.data here
            if (err.response.data && err.response.data.errors[0]) {
                dispatch({
                    type: PAGE_ACCESS_ERROR,
                    payload: err.response.data.errors[0]
                });
            } else {
                const error = err.response.data;
                dispatch({
                    type: PAGE_ACCESS_ERROR,
                    payload: err.message
                });
            }
        } else if (err.request) {
            // The request was made but no response was received
            // Error details are stored in error.reqeust
            dispatch({
                type: PAGE_ACCESS_ERROR,
                payload: err.request
            });
        } else if (err) {
            dispatch({
                type: PAGE_ACCESS_ERROR,
                payload: err.message
            });
        } else {
            // Some other errors
            dispatch({
                type: PAGE_ACCESS_ERROR,
                payload: "Something went wrong."
            });
        }
    }
};
